<!-- ── Dialog 1: Main steps (type/subtype/request/datetime/location) 869px ── -->
@if (currentStep() !== 'review_details') {
<p-dialog
  [visible]="true"
  [modal]="true"
  [style]="{ width: '869px', maxWidth: '95vw', margin: '1rem' }"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  [showHeader]="false"
  styleClass="requests-main-dialog"
>
  <div class="dialog-inner">
    <!-- ── Header ─────────────────────────────────────────────── -->
    <div class="dialog-header">
      @if (currentStep() !== 'type') {
        <button type="button" (click)="onBack()" class="back-btn">
          <img src="assets/icons/backward-arrow.svg" alt="Back" />
        </button>
      }

      <h2 class="dialog-title">
        @if (currentStep() === 'type') { Please select the service you're looking for }
        @else if (currentStep() === 'subtype') { {{ getDynamicHeader() }} services }
        @else if (currentStep() === 'request_type') { Service Category }
        @else if (currentStep() === 'pickup_datetime') { Pickup Date &amp; Time }
        @else if (currentStep() === 'pickup_location') { Enter Locations }
      </h2>

      <button type="button" (click)="onCloseDialog()" class="close-btn">
        <img src="assets/icons/dialog-cancel.svg" alt="close" />
      </button>
    </div>

    <!-- ── Body ───────────────────────────────────────────────── -->

    <!-- Step: Select Type -->
    @if (currentStep() === 'type') {
      <div class="mt-4">
        <p class="dialog-subtitle">Choose an option</p>
        @if (isLoadingServiceTypes()) {
          <div class="flex items-center justify-center py-8">
            <span class="text-[14px] text-gray-500">Loading service types...</span>
          </div>
        } @else {
          <div class="service-grid">
            @for (type of serviceTypes(); track type.service_type) {
              <button
                type="button"
                class="service-card"
                [class.service-card--active]="selectedServiceType()?.service_type === type.service_type"
                (click)="onServiceTypeClick(type)"
              >
                <div class="option-icon"
                  [class.option-icon--selected]="selectedServiceType()?.service_type === type.service_type">
                  <img [src]="getServiceIcon(type)" [alt]="type.label" class="w-10 h-10 object-contain" />
                </div>
                <div class="option-text flex-1">
                  <div class="option-title">{{ type.label }}</div>
                  <div class="option-description">{{ type.description }}</div>
                </div>
              </button>
            }
          </div>
        }
      </div>
    }

    <!-- Step: Select Subtype -->
    @if (currentStep() === 'subtype') {
      <div class="mt-4">
        <p class="dialog-subtitle">Choose an option</p>
        <div class="service-grid">
          @for (subType of availableSubTypes(); track subType.sub_service_type) {
            <button
              type="button"
              class="service-card"
              [class.service-card--active]="selectedSubType()?.sub_service_type === subType.sub_service_type"
              (click)="onSubTypeClick(subType)"
            >
              <div class="option-icon"
                [class.option-icon--selected]="selectedSubType()?.sub_service_type === subType.sub_service_type">
                <img [src]="getSubTypeIcon(subType)" [alt]="subType.label" class="w-full h-full object-contain" />
              </div>
              <div class="option-text flex-1">
                <div class="option-title">{{ subType.label }}</div>
                <div class="option-description">{{ subType.description }}</div>
              </div>
            </button>
          }
        </div>
      </div>
    }

    <!-- Step: Service Category -->
    @if (currentStep() === 'request_type') {
      <div class="mt-4">
        <p class="dialog-subtitle">Choose an option</p>
        <div class="request-type-grid">
          <button
            type="button"
            class="request-type-card"
            [class.request-type-card--active]="selectedRequestType() === 'on_demand'"
            (click)="onRequestTypeSelect('on_demand')"
          >
            <div class="request-type-icon">
              <img src="assets/icons/invite-only.svg" alt="On-Demand" />
            </div>
            <div class="request-type-text">
              <div class="request-type-title">On-Demand</div>
              <div class="request-type-desc">Request a service provider to come to you</div>
            </div>
          </button>

          <button
            type="button"
            class="request-type-card"
            [class.request-type-card--active]="selectedRequestType() === 'selected_shop'"
            (click)="onRequestTypeSelect('selected_shop')"
          >
            <div class="request-type-icon">
              <img src="assets/icons/person.png" alt="Select a laundry shop" />
            </div>
            <div class="request-type-text">
              <div class="request-type-title">Select a laundry shop</div>
              <div class="request-type-desc">Browse and pick from nearby laundry shops</div>
            </div>
          </button>
        </div>
      </div>
    }

    <!-- Step: Pickup Date & Time -->
    @if (currentStep() === 'pickup_datetime') {
      <div class="mt-[70px] mb-[80px] min-[640px]:mt-[114px] min-[640px]:mb-[80px]">
        <div class="flex gap-5 justify-center max-[639px]:flex-col max-[639px]:gap-[26px]">

          <!-- Date -->
          <div class="flex items-center gap-3 min-[640px]:w-[338px] relative">
            <div class="flex-1 border-2 border-[#D9DDE0] rounded-[5px] h-[63px] flex items-center justify-between bg-white pl-[38px]">
              <span class="text-base min-[640px]:text-[20px] text-[#232F40] font-semibold">
                {{ getFormattedDate() }} • {{ getDayOfWeek() }}
              </span>
              <button type="button" (click)="openDatePicker(dateInput4)"
                class="text-[#238EC6] border-2 border-[#D9DDE0] absolute right-0 bg-[#E8EDF0] w-[53px] flex items-center justify-center h-[63px] rounded-tr-[5px] rounded-br-[5px]">
                <img src="assets/icons/calendar_3.svg" alt="calendar" class="w-[34px] h-[34px]" />
              </button>
              <input
                #dateInput4
                type="date"
                [value]="selectedDate()"
                class="absolute opacity-0 pointer-events-none w-0 h-0"
                (change)="onDateChange($event)"
              />
            </div>
          </div>

          <div class="flex items-center gap-[18px] min-[640px]:gap-3">
            <!-- Hour Dropdown -->
            <div #hourButtonRef
              class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[188px] relative cursor-pointer"
              (click)="toggleHourDropdown($event)">
              <img src="assets/icons/clock-icon.svg" alt="time" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
              <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">{{ getHourLabel() }}</span>
              @if (showHourDropdown()) {
                <div class="time-dropdown" (click)="$event.stopPropagation()">
                  @for (hour of hoursList; track $index) {
                    <div class="time-item"
                      [class.selected]="selectedHour() === hour.value"
                      (click)="selectHour($index); $event.stopPropagation()">
                      {{ hour.title }}
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Minute/Duration Dropdown -->
            <div #minuteButtonRef
              class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[143px] relative cursor-pointer"
              (click)="toggleMinuteDropdown($event)">
              <img src="assets/icons/clock-icon.svg" alt="duration" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
              <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">{{ meetupDuration() }} mins</span>
              @if (showMinuteDropdown()) {
                <div class="time-dropdown" (click)="$event.stopPropagation()">
                  @for (min of minutesList; track $index) {
                    <div class="time-item"
                      [class.selected]="meetupDuration() === min"
                      (click)="selectMinute($index); $event.stopPropagation()">
                      {{ min }} mins
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="flex justify-end w-full absolute bottom-0 right-0 py-5 pr-[34px] min-[640px]:pr-10 bg-white border-t border-[#EBEFF2] rounded-bl-[10px] rounded-br-[10px]">
          <button type="button"
            class="text-white w-[117px] py-1 rounded-[5px] bg-[#238EC6] text-[16px] font-semibold hover:bg-[#238EC6]/80 transition"
            (click)="onPickupNext()">
            Next
          </button>
        </div>
      </div>
    }

    <!-- Step: Pickup Location -->
    @if (currentStep() === 'pickup_location') {
      <div class="ploc-layout">
        <!-- Left panel -->
        <div class="ploc-left">
          <!-- Input box -->
          <div class="ploc-input-card">
            <p class="ploc-input-label">Pickup Location</p>
            <div class="ploc-input-row">
              <input
                type="text"
                class="ploc-input"
                placeholder="Enter Pickup Location"
                [value]="addressInput()"
                (input)="onAddressInput($any($event.target).value)"
                (keyup.enter)="onAddressSearch()"
              />
              <button type="button" class="ploc-edit-btn" (click)="onAddressSearch()">
                <img src="assets/icons/pencil.svg" alt="edit" class="w-4 h-4" />
              </button>
            </div>
          </div>

          <!-- Suggestions -->
          @if (autocompleteResults().length > 0) {
            <div class="ploc-suggestions">
              <p class="ploc-suggestions-title">Select Address</p>
              @for (prediction of autocompleteResults(); track prediction.place_id) {
                <button
                  type="button"
                  class="ploc-suggestion-item"
                  (click)="onSelectAutocomplete(prediction)"
                >
                  {{ prediction.description }}
                </button>
              }
            </div>
          }
        </div>

        <!-- Right panel: Map -->
        <div class="ploc-map">
          <div #mapContainer class="ploc-map-container"></div>
        </div>
      </div>

      <!-- Footer -->
      <div class="ploc-footer">
        <button type="button" class="ploc-next-btn" (click)="onPickupLocationNext()">Next</button>
      </div>
    }

  </div>
</p-dialog>
}

<!-- ── Dialog 2: Review Details only — 532px, fresh instance ── -->
@if (currentStep() === 'review_details') {
<p-dialog
  [visible]="true"
  [modal]="true"
  [style]="{ width: '532px', maxWidth: '95vw', margin: '1rem' }"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  styleClass="requests-review-dialog"
>
  <ng-template #header>
    <div class="w-full flex items-center gap-2">
      <button type="button" (click)="onBack()" class="back-btn">
        <img src="assets/icons/backward-arrow.svg" alt="Back" />
      </button>
      <h2 class="dialog-title flex-1">Review Details</h2>
      <button type="button" (click)="onCloseDialog()" class="close-btn">
        <img src="assets/icons/dialog-cancel.svg" alt="close" />
      </button>
    </div>
  </ng-template>

  <!-- Review Body -->
  <div class="review-wrap">

      <!-- User + service row -->
      <div class="review-user-row">
        <div class="relative w-[44px] h-[44px] rounded-full overflow-hidden flex-shrink-0">
          <img [src]="getUserAvatar()" alt="avatar"
            [class.blur-sm]="isPictureBlocked(currentUser?.profile_picture_moderation_status)"
            class="review-avatar" />
          @if (isPictureBlocked(currentUser?.profile_picture_moderation_status)) {
          <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-4 h-4 pointer-events-none" />
          }
        </div>
        <p class="review-user-text">
          <strong>{{ getUserFullName() }}</strong> requesting service for
          <strong>{{ selectedServiceType()?.label }}</strong>
          <button type="button" class="review-edit-btn" aria-label="Edit service">
            <img src="assets/icons/pencil.svg" alt="edit" class="w-4 h-4" />
          </button>
        </p>
      </div>

      <!-- Chips row -->
      <div class="flex items-center gap-2 flex-wrap">
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition"
          (click)="goToStep('subtype')">
          {{ selectedSubType()?.label }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert" />
        </button>
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full hover:opacity-90 transition border"
          [class.bg-[#192A3E]]="selectedProvider()"
          [class.text-white]="selectedProvider()"
          [class.border-[#192A3E]]="selectedProvider()"
          [class.bg-white]="!selectedProvider()"
          [class.text-[#192A3E]]="!selectedProvider()"
          [class.border-[#D9DDE2]]="!selectedProvider()"
          (click)="openProviderPopup()">
          <div class="relative w-6 h-6 rounded-full border-2 border-white flex-shrink-0 flex items-center justify-center overflow-hidden bg-[#2E7FBE]" [class.opacity-50]="!selectedProvider()">
            @if (selectedProvider()) {
              @if (providerAvatar(selectedProvider()!); as avatar) {
                <img [src]="avatar" alt=""
                  [class.blur-sm]="isPictureBlocked(selectedProvider()?.profile_picture_moderation_status)"
                  class="w-full h-full object-cover" />
                @if (isPictureBlocked(selectedProvider()?.profile_picture_moderation_status)) {
                <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
                }
              } @else {
                <span class="text-white text-[10px] font-bold">{{ getInitials(selectedProvider()!) }}</span>
              }
            } @else {
              <img src="assets/images/dummy-avatar.jpg" alt="" class="w-full h-full object-cover opacity-50" />
            }
          </div>
          {{ selectedProvider() ? providerDisplayName(selectedProvider()!) : 'Select Preferred Shops' }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5" [class.brightness-0]="selectedProvider()" [class.invert]="selectedProvider()" />
        </button>
      </div>

      <!-- Pickup datetime -->
      <button type="button"
        class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] max-w-[320px] truncate rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition w-full"
        (click)="goToStep('pickup_datetime')">
        <img src="assets/icons/calendar_2.png" alt="cal" class="w-[18px] h-[18px] brightness-0 invert flex-shrink-0" />
        <span class="flex-1 text-left">Pickup on: <strong class="font-semibold">{{ getPickupDateTimeLabel() }}</strong></span>
        <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert flex-shrink-0" />
      </button>

      <!-- Pickup location -->
      <button type="button"
        class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition w-full"
        (click)="goToPickupLocation()">
        <img src="assets/icons/location-pin.svg" alt="location" class="w-[18px] h-[18px] brightness-0 invert flex-shrink-0" />
        <span class="flex-1 text-left truncate">Pickup at:
          <strong class="font-semibold">{{ selectedPickupAddress() || 'Add your pickup address' }}</strong>
        </span>
        <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert flex-shrink-0" />
      </button>

      <!-- Pricing card -->
      <div class="review-pricing-card">
        @if (isLoadingPricing()) {
          <div class="review-loading">Loading pricing...</div>
        } @else if (pricingData()) {
          <button type="button" class="review-total-row"
            (click)="showPricingBreakdown.set(!showPricingBreakdown())">
            <span class="review-total-label">Total Payment</span>
            <span class="review-total-amount">{{ formatCurrency(getPricingTotal()) }}</span>
            <img src="assets/icons/dropdown-arrow.svg" alt="" class="w-4 h-4 ml-2 transition-transform"
              [style.transform]="showPricingBreakdown() ? 'rotate(180deg)' : 'rotate(0)'" />
          </button>

          @if (showPricingBreakdown()) {
            <div class="review-breakdown">
              <p class="review-fee-section-label">Service Fees</p>
              <div class="review-fee-row">
                <span>Per lbs ({{ pricingData()!.per_lbs }}/lbs)</span>
                <span>1 lbs / {{ formatCurrency(pricingData()!.per_lbs) }}</span>
              </div>
              <div class="review-fee-row">
                <span>Minimum</span>
                <span>{{ formatCurrency(pricingData()!.minimum_fee) }}</span>
              </div>
              <div class="review-fee-row">
                <span>Delivery Fee</span>
                <span>{{ formatCurrency(pricingData()!.delivery_fee) }}</span>
              </div>
              <div class="review-fee-row">
                <span>One Day Rush ({{ formatCurrency(pricingData()!.one_day_rush_fee) }})</span>
                <span>$00.00</span>
              </div>

              <div class="review-fee-divider"></div>
              <p class="review-fee-section-label">Other Fees</p>

              <div class="review-fee-row">
                <span>Sales Tax</span>
                <span>{{ pricingData()!.sales_tax }}% / {{ formatCurrency(getPricingTax()) }}</span>
              </div>
              <div class="review-fee-row">
                <span>Convenient Fee</span>
                <span>{{ formatCurrency(CONVENIENT_FEE) }}</span>
              </div>

              <div class="review-how-it-works">
                <p class="review-how-title">How it works</p>
                <p class="review-how-desc">The total payment comprises sales tax and a convenience fee,
                  both of which depend on the chosen payment method and the applicable state regulations.</p>
              </div>
            </div>
          }
        }
      </div>

      <!-- Gallery -->
      <div class="review-gallery">
        <h4 class="review-gallery-title">Gallery</h4>
        <div class="flex items-center gap-2 overflow-x-auto overflow-y-visible hide-scrollbar py-2">

          <!-- Add button -->
          <label class="review-gallery-add cursor-pointer flex-shrink-0">
            <input
              type="file"
              accept="image/*"
              multiple
              class="hidden"
              (change)="onGalleryFileSelect($event)"
            />
            <img src="assets/icons/message-attach.svg" alt="gallery" />
            <span class="review-gallery-add-label">Gallery</span>
          </label>

          <!-- Selected images -->
          @for (item of galleryPreviews(); track $index) {
            <div class="relative min-w-[65px] w-[65px] h-[65px] flex-shrink-0">
              <img [src]="item.preview" class="w-full h-full rounded-[8px] object-cover border" alt="preview" />
              <button
                type="button"
                (click)="removeGalleryImage($index)"
                class="absolute -top-1.5 -right-1 w-4 h-4 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center z-10"
              >✕</button>
            </div>
          }

        </div>
      </div>

      <!-- Footer -->
      <div class="review-footer">
        <button type="button" class="review-create-btn" (click)="onCreateRequest()" [disabled]="isSubmitting()">
          @if (isSubmitting()) {
        <span class="loader-dot"></span>
        }
          {{ isSubmitting() ? (isEditMode() ? 'Updating...' : 'Creating...') : (isEditMode() ? 'Update Request' : 'Create Request') }}
        </button>
      </div>

    </div>
</p-dialog>
}

<!-- ── Request Created Success Popup ───── -->
@if (showSuccessPopup()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]">
    <div class="w-[482px] max-w-[95vw] border border-[#192A3E26] rounded-[16px] bg-white shadow-[0_18px_45px_rgba(0,0,0,0.15)] p-[50px_50px_70px_55px] flex flex-col text-left">
      <h2 class="text-[#192A3E] font-bold text-[32px] leading-8">Request Created!</h2>
      <div class="flex flex-col gap-6 border-t border-[#ebeff2] pt-[35px] mt-[44px] mb-10">
        <p class="text-[#4E4D4D] text-lg leading-6">Your request has been successfully created.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Please check your notifications for the latest updates and changes.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Thank you!</p>
      </div>
      <button type="button" class="text-[#192A3E] text-2xl leading-7 cursor-pointer font-medium" (click)="onSuccessOk()">
        OK
      </button>
    </div>
  </div>
}

<!-- ── Select Providers Popup ──────── -->
@if (showProviderPopup()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]">
    <div class="bg-white rounded-[16px] border border-[#E4E6E8] w-[820px] max-w-[95vw] max-h-[90vh] flex flex-col overflow-hidden">

      <!-- Header -->
      <div class="flex items-center gap-4 px-6 pt-6 pb-4">
        <button type="button" (click)="showProviderPopup.set(false)" class="flex-shrink-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back"/>
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1 leading-tight">Select Providers</h2>
        <p-iconfield iconPosition="left" class="w-[170px]">
          <p-inputicon>
            <img src="assets/icons/search.svg" width="16" />
          </p-inputicon>
          <input
            type="text"
            pInputText
            placeholder="Search"
            class="!rounded-full !border-[#D9DDE2] !bg-white !text-[13px] !text-[#192A3E]"
            [value]="providerSearch()"
            (input)="providerSearch.set($any($event.target).value)"
          />
        </p-iconfield>
        <button type="button" (click)="showProviderPopup.set(false)" class="flex-shrink-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" />
        </button>
      </div>

      <!-- Tabs -->
      <div class="flex items-center gap-2 px-6 pb-4">
        <button type="button"
          class="px-[18px] py-[6px] rounded-full text-[13px] font-semibold transition-colors"
          [class.bg-[#192A3E]]="providerTab() === 'all'"
          [class.text-white]="providerTab() === 'all'"
          [class.text-[#6B7280]]="providerTab() !== 'all'"
          (click)="providerTab.set('all')">All</button>
        <button type="button"
          class="px-[18px] py-[6px] rounded-full text-[13px] font-semibold transition-colors"
          [class.bg-[#192A3E]]="providerTab() === 'preferred'"
          [class.text-white]="providerTab() === 'preferred'"
          [class.text-[#6B7280]]="providerTab() !== 'preferred'"
          (click)="providerTab.set('preferred')">Preferred</button>
      </div>

      <!-- Grid -->
      <div class="flex-1 overflow-y-auto px-6 pb-6">
        @if (isLoadingProviders()) {
          <div class="flex items-center justify-center py-16">
            <span class="text-sm text-[#757A80]">Loading...</span>
          </div>
        } @else if (filteredProviders().length === 0) {
          <div class="flex items-center justify-center py-16">
            <span class="text-sm text-[#757A80]">No providers found.</span>
          </div>
        } @else {
          <div class="grid grid-cols-2 gap-3">
            @for (p of filteredProviders(); track p.user_id) {
              <div class="flex items-center gap-[14px] border border-[#E8ECEF] rounded-[10px] px-4 py-[14px]">
                @if (providerAvatar(p); as avatar) {
                  <div class="relative w-[52px] h-[52px] rounded-full overflow-hidden flex-shrink-0">
                    <img [src]="avatar" [alt]="providerDisplayName(p)"
                      [class.blur-sm]="isPictureBlocked(p.profile_picture_moderation_status)"
                      class="w-full h-full object-cover" />
                    @if (isPictureBlocked(p.profile_picture_moderation_status)) {
                    <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
                    }
                  </div>
                } @else {
                  <div class="w-[52px] h-[52px] rounded-full bg-[#2E7FBE] flex items-center justify-center text-white text-lg font-bold flex-shrink-0">
                    {{ getInitials(p) }}
                  </div>
                }
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-[6px] flex-wrap mb-[3px]">
                    <span class="text-[14px] font-bold text-[#192A3E] truncate">{{ providerDisplayName(p) }}</span>
                    @if (p.is_verified) {
                      <span class="flex items-center gap-[3px] bg-[#2AACA8] text-white text-[10px] font-semibold px-[7px] py-[2px] rounded-full flex-shrink-0">
                        <img src="assets/icons/check.svg" alt="" class="w-[10px] h-[10px] brightness-0 invert" />Verified
                      </span>
                    }
                  </div>
                  <div class="text-[12px] text-[#6B7280] truncate leading-5">{{ providerLocation(p) }}</div>
                  <div class="text-[12px] text-[#6B7280] leading-5">{{ p.role ?? p.service_type }}</div>
                </div>
                <button type="button" class="flex-shrink-0" (click)="selectProvider(p)">
                  <span class="text-[28px] font-light "
                    [class.text-[#238EC6]]="selectedProvider()?.user_id !== p.user_id"
                    [class.text-[#2AACA8]]="selectedProvider()?.user_id === p.user_id">
                    <img src="assets/icons/add-collab.svg" alt="add">
                  </span>
                </button>
              </div>
            }
          </div>
        }
      </div>

    </div>
  </div>
}

<!-- p-menu always outside dialogs -->
<p-menu
  #currentMenu
  [model]="currentMenuItems"
  [popup]="true"
  appendTo="body"
  styleClass="contact-action-menu"
>
  <ng-template pTemplate="item" let-item>
    <a
      class="p-menuitem-link p-2"
      (click)="item.command && item.command({ item: item })"
      style="display: flex; align-items: center; gap: 12px; text-decoration: none"
    >
      <span class="p-menuitem-text">{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>